// extracted by mini-css-extract-plugin
export default {"inner":"TermsPage_inner__CswJN","sidebar":"TermsPage_sidebar__5c0k5","content":"TermsPage_content__wKUzK"};